// extracted by mini-css-extract-plugin
export default {"expandableTextarea":"ExpandableTextarea_expandableTextarea__kdekk","emptyTextArea":"ExpandableTextarea_emptyTextArea__2Wwk9","charCount":"ExpandableTextarea_charCount__p8BcP"};